import { render, staticRenderFns } from "./FundSelector.vue?vue&type=template&id=ffa87fea&scoped=true&"
import script from "./FundSelector.vue?vue&type=script&lang=js&"
export * from "./FundSelector.vue?vue&type=script&lang=js&"
import style0 from "./FundSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FundSelector.vue?vue&type=style&index=1&id=ffa87fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa87fea",
  null
  
)

component.options.__file = "packages/cb-components-suitability/src/components/main/FundSelector.vue"
export default component.exports